import {MantineThemeOverride} from "@mantine/core";
import {otsThemeOverride} from "@ots-frontend/ots-ui";

export const themeOverride: MantineThemeOverride = {
    ...otsThemeOverride,
    // Same faces as ots-site: Inter for text, Lexend for headings.
    fontFamily: '"Inter Variable", "Inter", ui-sans-serif, system-ui, sans-serif',
    headings: {...otsThemeOverride.headings, fontFamily: '"Lexend Variable", "Lexend", "Inter Variable", "Inter", ui-sans-serif, system-ui, sans-serif'},
};
